import { FETCH_HEADER_DATA } from './constants'

const initialState = {
  header: {},
  isFetching: false,
  error: {}
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_HEADER_DATA['REQUEST']: {
      return {
        ...state,
        isFetching: true,
        header: {}
      }
    }
    case FETCH_HEADER_DATA['SUCCESS']: {
      return {
        ...state,
        isFetching: false,
        header: action.header
      }
    }
    case FETCH_HEADER_DATA['FAILURE']: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Header/reducer.js